/* eslint-disable */
import MedicalGroupApi from "../../pos-admin-module/api/medical-group-api";
import MessagingServiceApi from "../../pos-admin-module/api/messaging-service-api";
import PracticeGroupApi from "../../pos-admin-module/api/practice-group-api";
import PracticeTemplateApi from "../../pos-admin-module/api/practice-template-api";
import ClinicApi from "../../private-module/api/clinic-api";
import DynamicGroupApi from "../../private-module/api/dynamic-group-api";
import EmailApi from "../../private-module/api/email-api";
import IVRApi from "../../private-module/api/ivr-api";
import PracticeApi from "../../private-module/api/practice-api";
import SMSApi from "../../private-module/api/sms-api";
import TemplateApi from "../../private-module/api/template-api";
import PatientApi from "../../private-module/api/patient-api";
import StaticGroupApi from "../../private-module/api/static-group-api";

const Api = {
  practiceTemplate: PracticeTemplateApi,
  practiceGroup: PracticeGroupApi,
  template: TemplateApi,
  messagingService: MessagingServiceApi,
  email: EmailApi,
  sms: SMSApi,
  ivr: IVRApi,
  clinic: ClinicApi,
  dynamicGroup: DynamicGroupApi,
  medicalGroup: MedicalGroupApi,
  practice: PracticeApi,
  patient: PatientApi,
  staticGroupApi: StaticGroupApi
};

export default Api;
